<guarantees-search-field
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  icon="event"
  name="appointmentSearch"
  [placeholder]="display() || ('guaranteeV2.message.searchAppointment' | translate)"
  [value]="term()"
  [loading]="loading()"
  (valueChange)="search($event)"
  (opened)="unfold()"
  (closed)="open.set(false)"
></guarantees-search-field>

<!-- In an overlay, not in the flow: a list inside a dialog is cut off by the dialog's own scroll. -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="panelWidth()"
  [cdkConnectedOverlayMatchWidth]="true"
  (overlayOutsideClick)="open.set(false)"
  (detach)="open.set(false)"
>
  <guarantees-option-list
    [style.width.px]="panelWidth() || null"
    [error]="failed() ? ('guaranteeV2.message.appointmentSearchFailed' | translate) : ''"
    [empty]="results().length === 0 && !loading() && !failed()"
    [emptyMessage]="'guaranteeV2.message.noAppointments' | translate"
    [loading]="loading()"
    [loadingMessage]="'guaranteeV2.message.searchingAppointments' | translate"
  >
    @for (appointment of results(); track appointment.id) {
      <li>
        <button
          guaranteesOption
          type="button"
          [class]="appointment.id === selectedId() ? 'bg-primary-50' : ''"
          (click)="choose(appointment)"
        >
          <span class="shrink-0 font-semibold text-neutral-700 tabular-nums">{{ appointment.dateStart | date: "d MMM yy HH:mm" }}</span>

          <span class="min-w-0 flex-1 truncate text-neutral-600">
            {{ appointment.serviceName }}
            @if (appointment.doctorName) {
              <span class="text-neutral-400">· {{ appointment.doctorName }}</span>
            }
          </span>

          <!-- A cancelled booking is rarely what a guarantee answers, so its state is on the row. -->
          <span
            class="shrink-0 rounded-full px-1.5 py-0.5 text-xs font-semibold"
            [class]="
              appointment.status === statuses.Completed
                ? 'bg-success-50 text-success-700'
                : appointment.status === statuses.Cancelled || appointment.status === statuses.NoShow
                  ? 'bg-error-50 text-error-700'
                  : 'bg-neutral-100 text-neutral-500'
            "
            >{{ statusLabelKey[appointment.status] | translate }}</span
          >

          @if (hasGuarantee(appointment.id)) {
            <mat-icon
              class="h-4! w-4! shrink-0 text-base! leading-4! text-warning-500"
              [matTooltip]="'guaranteeV2.message.appointmentAlreadyGuaranteedHint' | translate"
              >verified</mat-icon
            >
          }
        </button>
      </li>
    }
  </guarantees-option-list>
</ng-template>
